import React, { useState } from 'react';
import axios from 'axios';
import './AddProductForm.css';

const AddProductForm = () => {
  const [activeTab, setActiveTab] = useState('main'); // состояние для отслеживания активной вкладки
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [mainImage, setMainImage] = useState(null);
  const [images, setImages] = useState([]); // Массив для дополнительных изображений
  const [prices, setPrices] = useState({
    priceOneHour: '',
    priceTwoHours: '',
    priceTravelOneHour: '',
    priceTravelTwoHours: '',
    priceWholeNight: '',
  });
  const [characteristics, setCharacteristics] = useState({
    age: '',
    height: '',
    weight: '',
    breast: '',
    shoeSize: '',
    clothingSize: '',
    district: '',
  });
  const [preferences, setPreferences] = useState({});
  const [contactPhone, setContactPhone] = useState('');
  const [message, setMessage] = useState('');

  // Метки для полей
  const priceLabels = {
    priceOneHour: 'Цена за 1 час',
    priceTwoHours: 'Цена за 2 часа',
    priceTravelOneHour: 'Цена за поездку (1 час)',
    priceTravelTwoHours: 'Цена за поездку (2 часа)',
    priceWholeNight: 'Цена за ночь',
  };

  const characteristicLabels = {
    age: 'Возраст',
    height: 'Рост (см)',
    weight: 'Вес (кг)',
    breast: 'Размер груди',
    shoeSize: 'Размер обуви',
    clothingSize: 'Размер одежды',
    district: 'Район',
  };

  const preferenceOptions = [
    {

   
      category: 'Что будет', options: ['Классический секс', 'Минет в презервативе', 'Минет без резинки', 'Минет глубокий', 'Куннилингус', 'Окончание на грудь', 'Окончание на лицо', 'Окончание в рот', 'Целуюсь', 'Госпожа', 'Рабыня', 'Классический массаж',
        '      Расслабляющий массаж', 'Урологический массаж', 'Эротический массаж', 'Профессиональный массаж', 'Стриптиз', 'Ролевые игры', 'Эскорт', 'Анальный секс', 'Золотой дождь', 'Страпон', 'Групповой секс', 'Легкое садо/мазо', 'Игрушки', 'Услуги семейным парам']
    },
    {
      category: 'Что может быть', options: ['Классический секс', 'Минет в презервативе', 'Минет без резинки', 'Минет глубокий', 'Куннилингус', 'Окончание на грудь', 'Окончание на лицо', 'Окончание в рот', 'Целуюсь', 'Госпожа', 'Рабыня', 'Классический массаж',
        '      Расслабляющий массаж', 'Урологический массаж', 'Эротический массаж', 'Профессиональный массаж', 'Стриптиз', 'Ролевые игры', 'Эскорт', 'Анальный секс', 'Золотой дождь', 'Страпон', 'Групповой секс', 'Легкое садо/мазо', 'Игрушки', 'Услуги семейным парам']
    },

  ];


  const handlePreferenceChange = (category, option) => {
    setPreferences((prevState) => {
      const categoryPreferences = prevState[category] || { options: [], prices: {} };
      const updatedOptions = categoryPreferences.options.includes(option)
        ? categoryPreferences.options.filter((item) => item !== option)
        : [...categoryPreferences.options, option];
  
      return {
        ...prevState,
        [category]: {
          ...categoryPreferences,
          options: updatedOptions,
        },
      };
    });
  };

  const handleAddImages = (e) => {
    setImages((prevImages) => [...prevImages, ...Array.from(e.target.files)]);
  };

  const handleRemoveImage = (index) => {
    setImages((prevImages) => prevImages.filter((_, i) => i !== index));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Проверка всех вкладок
    if (!title.trim()) {
      setMessage('Поле "Имя" обязательно для заполнения.');
      setActiveTab('main'); // Переключаемся на вкладку с ошибкой
      return;
    }

    if (!description.trim()) {
      setMessage('Поле "Послание посетителю" обязательно для заполнения.');
      setActiveTab('main');
      return;
    }

    if (!mainImage) {
      setMessage('Основное изображение обязательно для загрузки.');
      setActiveTab('main');
      return;
    }

    if (images.length < 2) {
      setMessage('Должно быть как минимум 2 дополнительных изображения.');
      setActiveTab('main');
      return;
    }

    if (!contactPhone.trim()) {
      setMessage('Поле "Контактный телефон" обязательно для заполнения.');
      setActiveTab('main');
      return;
    }

    // Проверка цен
    const emptyPrices = Object.entries(prices).some(([key, value]) => !value.trim());
    if (emptyPrices) {
      setMessage('Заполните все поля в разделе "Цены".');
      setActiveTab('prices');
      return;
    }

    // Проверка характеристик
    const emptyCharacteristics = Object.entries(characteristics).some(
      ([key, value]) => !value.trim()
    );
    if (emptyCharacteristics) {
      setMessage('Заполните все поля в разделе "Характеристики".');
      setActiveTab('characteristics');
      return;
    }

    // Проверка на основные и дополнительные предпочтения
    const hasPreferences = Object.keys(preferences).length > 0;
    if (!hasPreferences) {
      setMessage('Выберите хотя бы одно предпочтение в разделе "Основное и Дополнительно".');
      setActiveTab('preferences');
      return;
    }

    // Если все проверки пройдены, создаём товар
    const formData = new FormData();
    formData.append('title', title);
    formData.append('description', description);
    formData.append('mainImage', mainImage);
    formData.append('prices', JSON.stringify(prices));
    formData.append('characteristics', JSON.stringify(characteristics));
    formData.append('preferences', JSON.stringify(preferences));
    formData.append('phone', contactPhone);
    images.forEach((image) => formData.append('images', image));

    try {
      await axios.post('/api/products/create', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      });
      setMessage('Товар успешно создан!');
      setTimeout(() => {
        window.location.reload(); // Перезагрузка страницы после успешного создания
      }, 1500);
    } catch (error) {
      console.error(
        'Ошибка при создании товара:',
        error.response ? error.response.data : error.message
      );
      setMessage('Ошибка при создании товара.');
    }
  };


  return (
    <div className="add-product-form">
      <div className="tabs">
        <button
          className={`glow-on-hover2 ${activeTab === 'main' ? 'active' : ''}`}
          onClick={() => setActiveTab('main')}
        >
          Основные
        </button>
        <button
          className={`glow-on-hover2 ${activeTab === 'prices' ? 'active' : ''}`}
          onClick={() => setActiveTab('prices')}
        >
          Цены
        </button>
        <button
          className={`glow-on-hover2 ${activeTab === 'characteristics' ? 'active' : ''}`}
          onClick={() => setActiveTab('characteristics')}
        >
          Характеристики
        </button>
        <button
          className={`glow-on-hover2 ${activeTab === 'preferences' ? 'active' : ''}`}
          onClick={() => setActiveTab('preferences')}
        >
          Основное и Дополнительно
        </button>
      </div>

      <form onSubmit={handleSubmit}>
        {activeTab === 'main' && (
          <div className="tab-content">
            <h2>Добавить анкету</h2>
            <label>Имя:</label>
            <input
              type="text"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              required
            />

            <label>Послание посетителю:</label>
            <textarea
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              required
            />

            <label>Основное изображение:</label>
            <input
              type="file"
              accept="image/*"
              onChange={(e) => setMainImage(e.target.files[0])}
              required
            />

            <label>Дополнительные изображения (до 10):</label>
            <input
              type="file"
              accept="image/*"
              multiple
              onChange={handleAddImages}
            />

            <div className="image-gallery">
              {images.map((image, index) => (
                <div key={index} className="image-item">
                  <img
                    src={URL.createObjectURL(image)}
                    alt={`Изображение ${index + 1}`}
                    className="thumbnail"
                  />
                  <button
                    type="button"
                    onClick={() => handleRemoveImage(index)}
                  >
                    X
                  </button>
                </div>
              ))}
            </div>

            <label>Контактный телефон:</label>
            <input
              type="text"
              value={contactPhone}
              onChange={(e) => setContactPhone(e.target.value)}
              placeholder="+7 (XXX) XXX-XX-XX"
              required
            />
          </div>
        )}

        {activeTab === 'prices' && (
          <div className="tab-content">
            <h3>Цены:</h3>
            {Object.keys(prices).map((key) => (
              <div key={key}>
                <label>{priceLabels[key]}:</label>
                <input
                  type="number"
                  value={prices[key]}
                  onChange={(e) =>
                    setPrices({ ...prices, [key]: e.target.value })
                  }
                  required
                />
              </div>
            ))}
          </div>
        )}

        {activeTab === 'characteristics' && (
          <div className="tab-content">
            <h3>Характеристики:</h3>
            {Object.keys(characteristics).map((key) => (
              <div key={key}>
                <label>{characteristicLabels[key] || key}:</label>
                <input
                  type="text"
                  value={characteristics[key]}
                  onChange={(e) =>
                    setCharacteristics({ ...characteristics, [key]: e.target.value })
                  }
                />
              </div>
            ))}
          </div>
        )}

        {activeTab === 'preferences' && (
          <div>
            <h3> Основное и Дополнительно :</h3>
            {preferenceOptions.map((pref) => (
              <div key={pref.category} className="preference-group">
                <h4>{pref.category}</h4>
                {pref.options.map((option) => (
                  <div key={option} className="preference-option">
                    <label>
                      <div className="switch">
                        <input
                          type="checkbox"
                          checked={
                            (preferences[pref.category]?.options || []).includes(option)
                          }
                          onChange={() =>
                            handlePreferenceChange(pref.category, option)
                          }
                        />
                        <span className="slider"></span>
                      </div>
                      {option}
                    </label>
                    <input
                      type="number"
                      placeholder="Цена"
                      value={
                        preferences[pref.category]?.prices?.[option] || ''
                      }
                      onChange={(e) =>
                        setPreferences((prevState) => {
                          const updatedCategory = prevState[pref.category] || { options: [], prices: {} };
                          return {
                            ...prevState,
                            [pref.category]: {
                              ...updatedCategory,
                              prices: {
                                ...updatedCategory.prices,
                                [option]: e.target.value,
                              },
                            },
                          };
                        })
                      }
                      className="price-input"
                    />
                  </div>
                ))}
              </div>
            ))}
          </div>
        )}

        <button type="submit" className="submit-button">
          Создать товар
        </button>
        {message && <p>{message}</p>}
      </form>
    </div>
  );
};

export default AddProductForm;
